import { get, httpDelete, post, put } from "../../services/HttpService";

export class GstChallan {
  constructor(gstChallan = {}) {
    this.set(gstChallan);
  }

  //   static validations = {
  //     gstin: [],
  //     business_name: [],
  //   };

  /**
   * @memberof GstChallan
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`tax-payments/v1/internal/challans/gst/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
  * @memberof GstChallan
  * @type API
  * @returns Promise
  */
  downloadAdvice = (queryData = {}) => {
    return get(`tax-payments/v1/internal/challans/gst/${this.id}/download/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof GstChallan
   * @type API
   * @returns Promise
   */
  static triggerFetch = (queryData = {}) => {
    queryData = { ...queryData };
    return get(`tax-payments/v1/internal/challans/gst/fetch/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
 * @memberof GstChallan
 * @type API
 * @returns Promise
 */
  processPayment = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(`tax-payments/v1/internal/challans/gst/${queryData.id}/payment/initiate/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof GstChallan
* @type API
* @returns Promise
*/
  fetchPaymentAttempts = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return get(`tax-payments/v1/internal/challans/gst/${queryData.id}/payment/attempts/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof GstChallan
* @type API
* @returns Promise
*/
  approvePayment = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(`tax-payments/v1/internal/challans/gst/${queryData.approval_id}/approve_payment/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof GstChallan
* @type API
* @returns Promise
*/
  updateSourceAccount = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return put(`tax-payments/v1/internal/challans/gst/${queryData.id}/source_account/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof GstChallan
   * @type Setter Method
   * @takes GstChallan Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof GstChallan
   * @type Getter Method
   * @returns GstChallan
   */
  get = () => {
    return {
      id: this.id,
      account_id: this.account_id
      //   gstin: this.gstin,
      //   business_name: this.business_name,
    };
  };
}
